var VisaAndHealthService = /** @class */ (function () {
    function VisaAndHealthService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * GetDocumentTypes
     * @returns any Successful response
     * @throws ApiError
     */
    VisaAndHealthService.prototype.getApiV1VisaAndHealthGetDocumentTypes = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/visa-and-health/GetDocumentTypes',
        });
    };
    /**
     * GetIssuingCountries
     * @param term
     * @returns any Successful response
     * @throws ApiError
     */
    VisaAndHealthService.prototype.getApiV1VisaAndHealthGetIssuingCountries = function (term) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/visa-and-health/GetIssuingCountries',
            query: {
                'term': term,
            },
        });
    };
    /**
     * GetNationalityCountries
     * @param term
     * @returns any Successful response
     * @throws ApiError
     */
    VisaAndHealthService.prototype.getApiV1VisaAndHealthGetNationalityCountries = function (term) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/visa-and-health/GetNationalityCountries',
            query: {
                'term': term,
            },
        });
    };
    return VisaAndHealthService;
}());
export { VisaAndHealthService };
